//@flow
import * as React from 'react';
import AcknowledgeButton from 'app/common/react/components/growth/unauth/signup/AccountRecovery/AcknowledgeButton';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import ResetPasswordButton from 'app/common/react/components/growth/unauth/signup/AccountRecovery/ResetPasswordButton';
import { Box, Text } from 'gestalt';

type Props = {|
  email: string,
  onClose: () => void,
  onPasswordResetSent: () => void,
  socialButtons: React.Node,
|};

export default function LoginRateLimitedModal({
  email,
  onClose,
  onPasswordResetSent,
  socialButtons,
}: Props) {
  return (
    <Modal
      accessibilityCloseLabel={i18n._('close', 'accessible label for button to close modal')}
      accessibilityModalLabel={i18n._(
        'Login limit reached',
        'Modal accessibility label for users who have been login rate limited',
      )}
      heading={i18n._('Oops! Too fast', 'Modal heading for user who have been login rate limited')}
      onDismiss={onClose}
      role="alertdialog"
      size="md"
    >
      <Box paddingX={6} marginBottom={4}>
        <Box marginBottom={4} width="100%" overflow="hidden">
          <Text inline leading="tall">
            {i18n._(
              'It looks like you’re logging in a lot. Log in with Facebook or Google if you’re connected,' +
                ' or reset your password. Or you can wait 30 minutes and try again.',
              'Statement that the users is login limited',
            )}
          </Text>
        </Box>
        <Box marginBottom={4}>
          <Text>
            {i18n._(
              'Or log in with Facebook or Google.',
              'Upsell to use Facebook or Google for login',
            )}
          </Text>
        </Box>
        <ResetPasswordButton email={email} callBack={onPasswordResetSent} />
        {socialButtons}
        <Box marginTop={4}>
          <AcknowledgeButton
            onClick={onClose}
            overrideText={i18n._('I’ll wait', 'Button text acknowledging login rate limiting')}
          />
        </Box>
      </Box>
    </Modal>
  );
}
